module.exports = __webpack_public_path__ + "img/apiwise2.3cfa1d11.png";